import api from '../../utils/api'
import { useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

/* form */
import FormStockLot from './Form/FormStockLot'

function NewStockLot({ btCancelAction, handleOnSuccess, initialLot }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    async function registerLot(lot) {
        let msgType = 'success'

        const data = await api.post('/stock/lot/new', lot, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <FormStockLot title="Registrar Lote" handleSubmit={registerLot} btCancelAction={btCancelAction} btnText="Registrar" initialLot={initialLot} />
    )
}

export default NewStockLot
